<template>
  <div>

    <li>
      <div>
        <div class="form-check form-check-inline">
          <b-form-checkbox
            v-if="isSelectable"
            v-model="node.checked"
            :disabled="saving"
            :value="true"
            :unchecked-value="false"
            @input="onChecked"/>
          <template v-if="isSelectable">
            <b-button variant="link" style="padding:0" @click="openModal">
              {{ node.name }}
            </b-button>
          </template>
          <template v-else>
            {{ node.name }}&nbsp;
          </template>
          <span
            v-if="isFolder"
            :class="{ 'clickable' : isFolder }"
            @click="toggle">
            &nbsp;[{{ open ? '-' : '+' }}]
          </span>
        </div>
      </div>
      <ul v-show="open" v-if="isFolder">
        <node
          v-for="(node, index) in node.children"
          :class="{ 'topicNode' : node.type === 'topic' }"
          :key="index"
          :node="node"
          class="node"/>
      </ul>
    </li>

    <b-modal v-model="showPreviewModal" :title="modalTitle" centered hide-footer size="lg">
      <span v-if="fetchingModalData && Object.keys(modalData).length === 0">
        <i class="fas fa-spinner fa-spin"></i>
        Loading...
      </span>
      <moduleRow v-if="node.type === 'module'" :module="modalData"/>
      <componentRow v-if="node.type === 'component'" :component="modalData"/>
    </b-modal>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import moduleRow from '../modules/row'
import componentRow from '../components/row'

export default {
  name: 'node', // eslint-disable-line
  components: {
    moduleRow,
    componentRow
  },
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      open: false,
      showPreviewModal: false,
      modalData: {},
      fetchingModalData: false
    }
  },
  computed: {
    ...mapState('client', {
      tree: 'contentTree',
      saving: 'contentTreeSaving'
    }),
    isSelectable () {
      return this.node.type === 'module' || this.node.type === 'component'
    },
    isFolder () {
      return this.node.children && this.node.children.length
    },
    modalTitle () {
      const title = `${this.node.name} preview`
      return title.replace(/\w\S*/g, (txt) => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      })
    },
    checked () {
      return this.node.checked
    }
  },
  watch: {
    checked (newValue, oldValue) {
      if (this.node.type === 'component') {
        this.$store.dispatch('client/updateHiddenState', {
          moduleID: this.node.parentID,
          componentID: this.node.id,
          hidden: !this.node.checked
        })
      } else {
        this.$store.dispatch('client/updateHiddenState', {
          moduleID: this.node.id,
          hidden: !this.node.checked
        })
      }
    }
  },
  methods: {
    async openModal () {
      this.showPreviewModal = true

      if (this.node.type === 'module') {
        if (this.$store.getters['modules/exists'](this.node.id)) {
          this.modalData = this.$store.getters['modules/forClientByID'](this.node.id)
        }
        this.fetchingModalData = true
        await this.$store.dispatch('modules/show', {id: this.node.id})
        this.modalData = this.$store.state.modules.current
        this.fetchingModalData = false

      } else if (this.node.type === 'component') {
        if (this.$store.getters['components/exists'](this.node.id)) {
          this.modalData = this.$store.getters['components/forClientByID'](this.node.id)
        }
        this.fetchingModalData = true
        await this.$store.dispatch('components/show', {moduleID: this.node.parentID, id: this.node.id})
        this.modalData = this.$store.state.components.current
        this.fetchingModalData = false
      }
    },
    toggle () {
      if (this.isFolder) {
        this.open = !this.open
      }
    },
    onChecked () {
      if (this.node.type === 'component') {
        this.$store.commit('client/syncContentTreeCheckedState', this.node.parentID)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';
ul {
  padding-left: $spacing-sm;
  list-style-type: dot;
}

.topicNode {
  padding-left: 2.3rem;
  margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/client/content-tree/node.vue